import React, { Suspense, lazy } from "react";

import { useMap } from "./Map/hooks/useMap";

const MapFormComponent = lazy(() => import("./Map/NewMap"));

export type GeolocationProps = {
  defaultCoordinate?: {
    latitude?: number;
    longitude?: number;
    [key: string]: any;
  };
  children?: any;
  displayMap?: boolean;
  onDrageUpdate?: (location: any) => any;
  containerElement?: (displayMap: boolean, children: any) => React.ReactNode;
  mapElement?: React.ReactNode;
  mapContainerStyle?: any;
};

export const Geolocation: React.FC<GeolocationProps> = ({
  defaultCoordinate = { latitude: 6.45407, longitude: 3.39467 },
  children,
  mapContainerStyle,
  onDrageUpdate,
  displayMap,
  containerElement,
  mapElement,
}) => {
  const props = useMap(defaultCoordinate, onDrageUpdate);
  return (
    <Suspense fallback={<div></div>}>
      <MapFormComponent
        {...props}
        {...{ displayMap, containerElement, mapElement, mapContainerStyle }}
      >
        {typeof children === "function" ? children(props) : children}
      </MapFormComponent>
    </Suspense>
  );
};

export default Geolocation;
